import React, { useState } from 'react';

type TimeEntry = {
  startTime: string;
  startMeridiem: 'AM' | 'PM';
  endTime: string;
  endMeridiem: 'AM' | 'PM';
  projectTask: string;
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const TimeEntryModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const [entries, setEntries] = useState<TimeEntry[]>([
    { startTime: '', startMeridiem: 'AM', endTime: '', endMeridiem: 'PM', projectTask: '' }
  ]);

  const handleChange = (index: number, field: keyof TimeEntry, value: string) => {
    const updated = [...entries];
    updated[index][field] = value as any;
    setEntries(updated);
  };

  const handleAddEntry = () => {
    setEntries([
      ...entries,
      { startTime: '', startMeridiem: 'AM', endTime: '', endMeridiem: 'PM', projectTask: '' }
    ]);
  };

  const handleSave = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white w-full max-w-xl rounded-lg p-6 shadow-lg">
        <h2 className="text-2xl font-semibold text-green-700 mb-2">Enter Time Worked</h2>
        <p className="text-gray-800 text-lg mb-4">Sunday, Apr 6</p>

        {entries.map((entry, index) => (
          <div key={index} className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            {/* Start Time */}
            <div className="flex items-center space-x-2">
              <input
                type="text"
                placeholder="hh:mm"
                value={entry.startTime}
                onChange={(e) => handleChange(index, 'startTime', e.target.value)}
                className="w-24 p-2 border rounded"
              />
              <select
                value={entry.startMeridiem}
                onChange={(e) => handleChange(index, 'startMeridiem', e.target.value)}
                className="p-2 border rounded"
              >
                <option>AM</option>
                <option>PM</option>
              </select>
            </div>

            {/* End Time */}
            <div className="flex items-center space-x-2">
              <input
                type="text"
                placeholder="hh:mm"
                value={entry.endTime}
                onChange={(e) => handleChange(index, 'endTime', e.target.value)}
                className="w-24 p-2 border rounded"
              />
              <select
                value={entry.endMeridiem}
                onChange={(e) => handleChange(index, 'endMeridiem', e.target.value)}
                className="p-2 border rounded"
              >
                <option>AM</option>
                <option>PM</option>
              </select>
            </div>

            {/* Project Task */}
            <select
              value={entry.projectTask}
              onChange={(e) => handleChange(index, 'projectTask', e.target.value)}
              className="p-2 border rounded w-full"
            >
              <option value="">--Select Project/Task--</option>
              <option value="development">Development</option>
              <option value="meeting">Meeting</option>
              <option value="support">Support</option>
            </select>
          </div>
        ))}

        {/* Add Entry Button */}
        <div
          onClick={handleAddEntry}
          className="text-blue-600 hover:underline cursor-pointer mb-4"
        >
          + Add Entry
        </div>

        {/* Day Total */}
        <p className="text-sm text-gray-500 mb-4">
          Day Total: {entries.length} entr{entries.length > 1 ? 'ies' : 'y'}
        </p>

        {/* Buttons */}
        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 border rounded text-gray-600"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-green-600 text-white rounded"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default TimeEntryModal;
